export const PublicProgramKeys = {
  allPublicPrograms: ['public-programs'] as const,
} as const
